module.exports = __webpack_public_path__ + "img/arrow-icon.bcc0f9a1.svg";